/** Topics are never deleted, because past assignments refer to them. `Deprecated` retires one. */
export enum TaxonomyStatus {
  Active = 'active',
  Deprecated = 'deprecated',
}

/** The level of the taxonomy a question count is taken at. */
export enum TaxonomyNodeKind {
  Topic = 'topic',
  Group = 'group',
  Grouping = 'grouping',
  Subject = 'subject',
}
